<template>
    <div :class="$style.root">

        <div>
            <div style="line-height:40px;font-size:16px;margin-left:20px"> <a-icon :style="{ fontSize: '26px', color: '#ddd' }" type="star" /> 我的收藏</div>

            <collect />


        </div>
    </div>
</template>
<script>

    import collect from './components/collectView.vue';


    export default {
        filters: {},
        components: {
            collect,

        },
        data() {
            return {
                mode: 'inline',
                theme: 'light',
                selected: 1,
            };
        },
        methods: {
            changeMode(checked) {
                this.mode = checked ? 'vertical' : 'inline';
            },
            changeTheme(checked) {
                this.theme = checked ? 'dark' : 'light';
            },
            selectTab(sec) {
                this.selected = sec;
            },
        },
    };
</script>
<style lang="less" module>
    .root {
        margin: auto;
        margin: auto;
        max-width: 1200px;

        /* background: #f0f3f9; */
        // padding-top: 20px;
        display: flex;
        flex-direction: row;
        // margin-top: 20px;

        :global {
            .high-box {
                // padding-bottom: 50px;
                // padding-top: 50px;
            }

            .video-box {
                width: 275px;
                margin: 0 10px 20px;
                height: 260px;
                float: left;
                cursor: pointer;

            }

            .video-box:hover {
                background: #f0f3f9;
                -moz-box-shadow: 0 0 10px #888; /* 老的 Firefox */
                box-shadow: 0 0 10px #888;
            }

            .video-box:hover .video-title {
                width: 260px;
                // margin: 10px 10px 0;
            }


            .video-img {
                width: 100%;
                height: 158px;
                overflow: hidden;
            }

            .video-img img {
                transition: all 0.6s;

                height: 158px;
            }

            .video-box:hover .video-img img {
                transform: scale(1.2);
            }
            .g-bottom-f {
                line-height: 40px;
                display: flex;
                justify-content: right;
            }
        }
    }
</style>
